import { useState } from "react";

import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout";
import { UserProfileButton } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfileButton";
import { UserProfilePopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout";
import { UserProfileUnauthenticatedItems } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfileUnauthenticatedItems";
import useUser from "@/users/useUser";

export const USER_PROFILE_MENU_ID = "nav-user-profile-menu";

const UserProfileMenu = () => {
  const { data: user } = useUser();
  const [isOpen, setIsOpen] = useState(false);

  if (!user?.is_authenticated) return <UserProfileUnauthenticatedItems />;

  return (
    <NavButtonWithPopout
      id="nav-user-profile-menu"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      position={{ top: "3.4rem", right: "0rem" }}
      ButtonComponent={
        <UserProfileButton isOpen={isOpen} setIsOpen={setIsOpen} />
      }
      PopoutComponent={<UserProfilePopout />}
    />
  );
};

UserProfileMenu.displayName = "UserProfile";
export { UserProfileMenu };
